import { render, staticRenderFns } from "./ModalSelectionConflict.vue?vue&type=template&id=55a744a5&"
import script from "./ModalSelectionConflict.vue?vue&type=script&lang=js&"
export * from "./ModalSelectionConflict.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelectionConflict.vue?vue&type=style&index=0&id=55a744a5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports